import { includes, map, get, filter, isEmpty, every, groupBy, presence, some } from 'lodash'

const filteredVcenterAssets = (filters, assets) => filter(assets, (asset) => {
  const filterResults = {}

  if (filters.datacentre != 'All') {
    filterResults['datacentre'] = includes(map(filters.datacentre, 'value'), get(asset, 'site_code'))
  }

  if (filters.client != 'All') {
    filterResults['client'] = includes(map(filters.client, 'value'), get(asset, 'viaje_client_id'))
  }

  if (filters.status != 'All') {
    filterResults['status'] = includes(map(filters.status, 'value'), get(asset, 'lifecycle_status'))
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

export { filteredVcenterAssets }
